import React from 'react'


const Chat = (props) =>
    <svg xmlns="http://www.w3.org/2000/svg"
         {...props}
         preserveAspectRatio="xMidYMid" viewBox="0 0 32 31">
        <path d="M31.301 30.954a.999.999 0 0 1-1.12-.381L26.979 26H12.075A3.078 3.078 0 0 1 9 22.926V20a1 1 0 0 1 2 0v2.926c0 .592.482 1.074 1.075 1.074H27.5c.03 0 .055.014.085.017.068.006.131.02.197.04a.875.875 0 0 1 .329.171c.054.043.102.087.147.14.018.022.044.034.061.059l1.681 2.4V12.076c0-.593-.482-1.076-1.075-1.076H26a1 1 0 0 1 0-2h2.925A3.079 3.079 0 0 1 32 12.076V30a1 1 0 0 1-.699.954zM19.925 17H5.021l-3.202 4.573A.999.999 0 0 1 0 21V3c0-1.682 1.351-3 3.075-3h16.85C21.649 0 23 1.318 23 3v10.926A3.078 3.078 0 0 1 19.925 17zM21 3c0-.57-.462-1-1.075-1H3.075C2.462 2 2 2.43 2 3v14.828l1.681-2.401c.016-.024.042-.036.061-.058a.953.953 0 0 1 .149-.142c.049-.039.098-.074.152-.103.056-.029.113-.048.175-.067a.958.958 0 0 1 .2-.04c.028-.002.053-.017.082-.017h15.425c.593 0 1.075-.482 1.075-1.074V3z"
              fillRule="evenodd"/>
    </svg>

export default Chat


// WEBPACK FOOTER //
// ./src/components/_common/_icons/Chat.js